export default __webpack_public_path__ + "static/media/pudim.1060fb87.jpg";